module.exports = __webpack_public_path__ + "img/ys.4e84969e.png";